import styled from "styled-components";
import { projects } from "../data";
import parse from "html-react-parser";
const Portfolio = ({ t }) => {
  return (
    <div className="wrapper">
      <StyledContent className="content" id="portfolio">
        <div className="portfolio-title">
          <h1>PORTFOLIO</h1>
        </div>

        <div className="grid">
          {projects.map((project) => (
            <div className="grid-item ekolandia" key={project.imgAlt}>
              <div className="image-hidden">
                <img
                  height="300px"
                  width="500px"
                  src={project.cdnImgLink}
                  alt={project.imgAlt}
                />
              </div>
              <p> {parse(t(project.projectDesc))}</p>

              <div className="links">
                <a
                  href={project.projectLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("podglad")}
                
                </a>
                {project.projectRepo && (
                <a
                  href={project.projectLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("GITHUB REPO")}
                
                </a>)}
              </div>
           
            </div>
          ))}
        </div>
      </StyledContent>
    </div>
  );
};

export default Portfolio;

const StyledContent = styled.div`

.links { 
  margin-top: 2em;
  display: flex; 
  gap: 3rem;
  text-transform: uppercase;
}

  .ekolandia {
    border: 1px solid white;
    margin: 2em;
    width: 95%;
    box-shadow: 20px 20px 0 #221b1a;
    position: relative;
  }

  @media (max-width: 500px) {
    .ekolandia {
      width: 90%;
      margin: 3em;
      box-shadow: 13px 13px 0 #221b1a;
    }
  }

  .portfolio-title {
  }
  h1 {
    padding: 2rem;
    color: #f8f8f8;
    font-size: 6rem;
  }
  .grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
  }

  .grid-item {
    padding: 2rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 3rem;

    .image-hidden {
      grid-row: span 2;
      position: relative;
      z-index: 21;
      overflow: hidden;
    }

    p {
      font-size: 2rem;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      grid-row: span 3;
      filter: grayscale(20%);
      transition: all 1s ease;
    }
    img:hover {
      filter: none;
      transform: scale(1.02);
    }
    a {
      align-self: start;
      grid-column: 2;
      position: relative;
      z-index: 21;
      font-size: 1.2rem;
    }

   
    a,
    p {
      font-size: 2rem;
      color: #f8f8f8;
    }
  }

  @media (max-width: 768px) {
    .image-hidden {
      grid-column: span 2;
      grid-row: 1;
    }
    .grid-item {
      p {
        padding: 2rem 0rem 1.5rem 0rem;
        grid-column: span 2;
        grid-row: 3;
      }
      a {
        grid-column: span 2;
        font-size: 2rem;
      }
    }
  }
`;
